import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 5px 10px;
  border-radius: 6px;
  cursor: pointer;
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 10px;
    right: 10px;
    height: 2px;
    background-color: var(--color-primary);
    border-radius: 1px;
    display: ${({ $isActive }) => ($isActive ? 'block' : 'none')};
  }
`;

export const LinkContainer = styled(NavLink).attrs(({ $isExternal }) =>
  $isExternal
    ? {
        target: '_blank',
        rel: 'noopener noreferrer',
      }
    : {}
)`
  display: block;
  font-family: 'Geist', sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: ${({ $isActive }) => ($isActive ? 'var(--color-primary)' : 'var(--color-grey-73)')};
  white-space: nowrap;
  text-decoration: none;
`;
